var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.0013H17.14L20.77 16.6413C20.9397 16.437 21.0214 16.1738 20.997 15.9093C20.9726 15.6449 20.8442 15.401 20.64 15.2313C20.4358 15.0615 20.1725 14.9799 19.9081 15.0042C19.6436 15.0286 19.3997 15.157 19.23 15.3613L14.23 21.3613C14.1964 21.409 14.1663 21.4591 14.14 21.5113C14.14 21.5613 14.14 21.5913 14.07 21.6413C14.0247 21.7559 14.0009 21.878 14 22.0013C14.0009 22.1245 14.0247 22.2466 14.07 22.3613C14.07 22.4113 14.07 22.4413 14.14 22.4913C14.1663 22.5434 14.1964 22.5935 14.23 22.6413L19.23 28.6413C19.324 28.7541 19.4418 28.8449 19.5748 28.9071C19.7079 28.9694 19.8531 29.0015 20 29.0013C20.2337 29.0017 20.4601 28.9203 20.64 28.7713C20.7413 28.6873 20.825 28.5842 20.8863 28.4679C20.9477 28.3515 20.9855 28.2242 20.9975 28.0932C21.0096 27.9622 20.9957 27.8302 20.9567 27.7046C20.9176 27.579 20.8542 27.4623 20.77 27.3613L17.14 23.0013H27C27.2652 23.0013 27.5196 22.8959 27.7071 22.7084C27.8946 22.5208 28 22.2665 28 22.0013C28 21.736 27.8946 21.4817 27.7071 21.2941C27.5196 21.1066 27.2652 21.0013 27 21.0013Z",
    fill: "#FA9418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5119c7ece74daa98564f9236c789e243.svg";
export { ForwardRef as ReactComponent };